import Cookies from "js-cookie";
import { showClearCacheOption } from "@/composables/useClearCache";

const checkForUpdates = () => {
  const currentVersion = Cookies.get("erp_version");
  console.info("Current version:", currentVersion);

  const intervalId = setInterval(() => {
    const newVersion = Cookies.get("erp_version");

    if (currentVersion && newVersion && newVersion !== currentVersion) {
      console.info("New version detected:", newVersion);
      showClearCacheOption.value = true;
      clearInterval(intervalId);
    }
  }, 60000);
};

export default checkForUpdates;
